module.exports = __webpack_public_path__ + "img/logo_emof.953ed195.png";